import Vue from 'vue';
import Vuex from "vuex";
import axios from 'axios';
import VueAxios from 'vue-axios';
import UniqueId from 'vue-unique-id';
import * as VueGoogleMaps from "vue2-google-maps"
import { mapActions } from 'vuex';

import createStore from './store/index.js'
import UtilsPlugin from './utils/index.js';
import components from './components/index.js';
import { EventBus } from "./EventBus.js";
import _ from 'lodash';

import 'vue-glide-js/dist/vue-glide.css'

import 'tw-elements';
import 'swiper/swiper-bundle.css'

import Flicking from "@egjs/vue-flicking";
import "@egjs/vue-flicking/dist/flicking.css";

import { IbexaPageBuilderBlockRefresher } from '@aplyca/ibexa-pagebuilder-block-refresher';

import { register } from 'swiper/element/bundle';
register();

import Alpine from 'alpinejs'

Vue.use(Vuex);
Vue.use(_);
Vue.use(VueAxios, axios);
Vue.use(UtilsPlugin, {
  eventBus: EventBus
});
Vue.use(VueGoogleMaps);
Vue.use(UniqueId);
Vue.use(Flicking);

Vue.filter('filterPrice', (str) => {
  return str.toLocaleString("es-CO", {
    style: 'currency',
    currency: "COP",
    maximumFractionDigits: 0
  })
});

for (let componentKey in components) {
  Vue.component(componentKey, components[componentKey])
}

new Vue({
  el: '#app',
  store: createStore(Vuex),
  delimiters: ["${", "}"],
  data() {
    return {
      isOpen: false
    }
  },
  mounted() {
    IbexaPageBuilderBlockRefresher("3.*", (blockElement) => {
      new Vue({
        el: blockElement,
        store: createStore(Vuex),
        delimiters: ["${", "}"]
      });
    });
    window.addEventListener('load', () => {
      this.$store.commit('Map/setWLoad');
    });
    this.getMegamenuContent();
    this.onStickySidebar();
    window.addEventListener("resize", this.onStickySidebar);
  },
  methods: {
    ...mapActions({
      getMegamenus: 'getMegamenusRequest'
    }),
    getMegamenuContent() {
      const header = document.getElementById("header");
      if(header){
        const endpoint = header.getAttribute("data-endpoint");
        this.getMegamenus(endpoint)
          .then(() => {
            setTimeout(() => {
              this.setItemsFocusEvent();
            }, 150);
          })
          .catch(err => console.log(err));
      }
    },
    setItemsFocusEvent() {
      const items = document.querySelectorAll('.header-nav__item--link');
      items.forEach(element => {
        element.firstChild.setAttribute('tabindex', '-1');
        element.setAttribute('tabindex', '0');
        element.addEventListener('mouseover', () => {
          const { activeElement } = document;
          if (activeElement && activeElement.classList.contains('header-nav__item--link-primary')) {
            activeElement.blur();
            element.focus();
          }
        })
      });
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
      document.body.classList.toggle('megamenu-is-open');
    },
    onStickySidebar() {
      const $sidebar = this.$el.querySelector(".layout--info-page__sidebar .sidebar_wrapper");
      const $header = this.$el.querySelector("header#header");
      if ($sidebar && $header) {
        $sidebar.style.top = `${$header.offsetHeight + 20}px`
      }
    }
  }
});

window.Alpine = Alpine;

Alpine.data('header', () => ({
  init() {
    this.onScrollTopSensor();
    document.addEventListener("scroll", () => {
      this.onScrollTopSensor();
    });
  },
  onScrollTopSensor(event) {
    const scrollTop = event?.target?.documentElement?.scrollTop || document.documentElement?.scrollTop;

    if (scrollTop > 300)
      this.$el.classList.remove('isTop');
    else
      this.$el.classList.add('isTop');
  }
}));

import Swiper from "swiper"
import { Pagination as SwiperPagination, Thumbs, Autoplay as SwiperAutoplay, EffectFade } from 'swiper/modules';


Alpine.data('primaryBanner', () => ({
  init() {
    const $Swiper = this.$refs["swiper"];
    const $elPagination = $Swiper.querySelector('.swiper-pagination');
    
    if ($Swiper) {
      const config = {
        modules: [SwiperPagination, SwiperAutoplay, Thumbs, EffectFade],
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        speed: 800,
        autoplay: {
          delay: 9000
        },
        pagination: {
          el: $elPagination,
          type: 'bullets',
          clickable: true
        }
      }

      const $Pagination = this.$refs["pagination"];
      if ($Pagination) {
        const $pagination = new Swiper($Pagination, {
          speed: 800,
          direction: "vertical",
          slidesPerView: 3,
          slidesPerGroup: 1,
          centeredSlides: true
        });

        Object.assign(config, {
          thumbs: {
            swiper: $pagination,
            autoScrollOffset: 0.5
          }
        })
      }

      new Swiper($Swiper, config);
    }
  }
}));

Alpine.start();